import { render, staticRenderFns } from "./SurveyComponent.vue?vue&type=template&id=0fc8dfc8&scoped=true&"
import script from "./SurveyComponent.vue?vue&type=script&lang=js&"
export * from "./SurveyComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc8dfc8",
  null
  
)

export default component.exports